export const FEEDBACK_CN_FORM = "https://bt.sg//CNtransfdbk";
